/* Automatic camera presets of the Create Class form's 3D preview (hoodie-1 template
 * views, see @ajat/design-system/Product3DPreview/templates/hoodie-1/model.json): uploading a
 * drawing or changing the back-print size turns the model to the print the customer just
 * touched, like the product page's per-attribute camera presets. */
export const UPLOAD_PRESET = { front: 'schoolLogoFront', back: 'backPrint' };
export const BACK_PRINT_SIZE_PRESET = 'backPrint';

/** Preset after an upload on `side`; a cleared upload returns to the plain side view. */
export function presetForUpload(side, file) {
  if (!file) return side === 'back' ? 'back' : 'front';
  return UPLOAD_PRESET[side] || 'front';
}
